// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AjaxContentController from "./ajax_content_controller"
application.register("ajax-content", AjaxContentController)

import AnchorController from "./anchor_controller"
application.register("anchor", AnchorController)

import CollectController from "./collect_controller"
application.register("collect", CollectController)

import ColumnChartController from "./column_chart_controller"
application.register("column-chart", ColumnChartController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import FavBtnsController from "./fav_btns_controller"
application.register("fav-btns", FavBtnsController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)

import FooterAdController from "./footer_ad_controller"
application.register("footer-ad", FooterAdController)

import FundCompareController from "./fund_compare_controller"
application.register("fund-compare", FundCompareController)

import FundController from "./fund_controller"
application.register("fund", FundController)

import JsLazyLoadingController from "./js_lazy_loading_controller"
application.register("js-lazy-loading", JsLazyLoadingController)

import NewsFundLikeController from "./news_fund_like_controller"
application.register("news-fund-like", NewsFundLikeController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import RecentlyStocksController from "./recently_stocks_controller"
application.register("recently-stocks", RecentlyStocksController)

import RecommendedNewsChartController from "./recommended_news_chart_controller"
application.register("recommended-news-chart", RecommendedNewsChartController)

import RedactorController from "./redactor_controller"
application.register("redactor", RedactorController)

import ReturnStdevyPointChartController from "./return_stdevy_point_chart_controller"
application.register("return-stdevy-point-chart", ReturnStdevyPointChartController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SimpleSpiderChartController from "./simple_spider_chart_controller"
application.register("simple-spider-chart", SimpleSpiderChartController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import SpiderHighChartController from "./spider_high_chart_controller"
application.register("spider-high-chart", SpiderHighChartController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
